import { Component, ComponentInterface, Event, EventEmitter, h, Prop } from '@stencil/core';

/**
 * @internal
 */
@Component({
  tag: 'bahf-cd-checkbox',
  styleUrl: 'bahf-cd-checkbox.scss',
  shadow: false,
  scoped: false,
})
export class BahfCdCheckbox implements ComponentInterface {
  @Prop() inputId: string;
  @Prop() inputName: string;
  @Prop() inputTitle: string;
  @Prop() label: string;
  @Prop() checked: boolean = false;
  @Prop() expanded: boolean = false;
  @Prop() disabled: boolean = false;

  @Event({
    eventName: "toggle", //do not rename, it's default event name for this event
    composed: false,
    cancelable: false,
    bubbles: false,
  })
  onToggle: EventEmitter;

  constructor() {
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    this.onToggle.emit();
  }

  render() {
    const { inputId, inputName, inputTitle, label, checked, disabled, handleToggle } = this;

    return (
      <div class={`form-check ${disabled ? 'always-checked-box' : ''}`}>
        {disabled ? (
          <span aria-hidden="true" class="ba-icon ba-icon-check" id={inputId} data-testid={`${inputId}-label`}></span>
        ) : (
          <input id={inputId} type="checkbox" name={inputName} checked={checked} title={inputTitle}
                 data-testid={`${inputId}-input`}
          onChange={handleToggle}/>
        )}
        <label htmlFor={inputId} data-testid={`${inputId}-label`}>{label}</label>
      </div>
    );
  }
}
